// extracted by mini-css-extract-plugin
module.exports =  {"root":"nnCZNkBSlcb2LPGS4k2Q"};